// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://oknfagfadqcydkumdeje.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9rbmZhZ2ZhZHFjeWRrdW1kZWplIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzQyMTU3OTAsImV4cCI6MjA4OTc5MTc5MH0.GGh9DIApy8jLomtqbtUsjVCZIjqFmIrhXwhTUANmX_k";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});